import React, { Component } from "react";
import Card from "react-md/lib/Cards/Card";
import CardTitle from "react-md/lib/Cards/CardTitle";
import Button from "react-md/lib/Buttons";
import Avatar from "react-md/lib/Avatars";
import CardText from "react-md/lib/Cards/CardText";
import FontIcon from "react-md/lib/FontIcons";
import Link from "gatsby-link";
import Media, { MediaOverlay } from "react-md/lib/Media";
import PostTags from "../PostTags/PostTags";
import "./PostPreview.scss";
import SVGIcon from 'react-md/lib/SVGIcons';
import Img from "gatsby-image"

const ArrowDown = props => (
  <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/>
    <path d="M0-.75h24v24H0z" fill="none"/>
  </svg>
);

class PostPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobile: true
    };
    this.handleResize = this.handleResize.bind(this);
  }
  componentDidMount() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    if (window.innerWidth >= 640) {
      this.setState({ mobile: false });
    } else {
      this.setState({ mobile: true });
    }
  }
  render() {
    const { postInfo } = this.props;
    const { mobile } = this.state;
    const expand = mobile;
    /* eslint no-undef: "off"*/
    const cover = postInfo.cover
      ? __PATH_PREFIX__ + postInfo.cover
      : postInfo.cover.startsWith("/");
    const coverHeight = mobile ? 162 : 225;
    return (
      <Card 
      key={postInfo.path} 
      raise 
      className="md-grid md-cell md-cell--4"
      expanderIcon={<ArrowDown />}>
        <Link style={{ textDecoration: "none" }} to={postInfo.path}>
          <Media
            style={{
              height: `${coverHeight}px`
            }}
            className="post-preview-cover"
          >
          <Img sizes={postInfo.cover}/>
          </Media>
          <CardTitle title={postInfo.title}>
            {/*<Button raised secondary className="md-cell--right">
              Read
            </Button>*/}
          </CardTitle>
        </Link>
        {/* expander={expand}*/}
        <CardTitle
          avatar={<Avatar icon={<FontIcon iconClassName="fa fa-calendar" />} />}
          title={`نشر في ${postInfo.date}`}
          subtitle={`${postInfo.timeToRead} دقائق قراءة`}
          className="meta-wrapper"
        />

        {/*<CardText expandable={expand}>
          {postInfo.excerpt}
          <PostTags tags={postInfo.tags} />
        </CardText>*/}
      </Card>
    );
  }
}

export default PostPreview;



// WEBPACK FOOTER //
// ./src/components/PostPreview/PostPreview.jsx